import Icon from '@/components/snippets/icon/icon'
import { useSort } from 'libs/searchspring/hooks/useSort'

export function FilterSortAccordion() {
  const { sorts, activeSort, handleSort, resetSort } = useSort()
  const id = 'filter-sort-sidebar'

  return (
    <x-modal data-id={id} className="dropdown-modal flex flex-col border-b group/filter border-neutral-medium">
      <button
        className="flex items-center justify-between gap-x-0.75 px-1 lg:px-0 py-1 link-fade"
        data-modal-parent={id}
        data-modal-role="toggle"
        aria-label="Sort By"
      >
        <span className="paragraph-m font-medium capitalize">Sort By</span>
        <div className={'flex w-[18px] h-[18px] group-data-visible/filter:-rotate-180 transition-all children:size-full'}>
          <Icon id="plus" className='group-data-visible/filter:hidden' />
          <Icon id="minus" className='hidden group-data-visible/filter:block' />
        </div>
      </button>
      <div className="dropdown-content">
        <div className="flex flex-col gap-1.5 overflow-hidden opacity-0 group-data-visible/filter:opacity-100 transition-all px-1 lg:px-0">
          <div className="flex flex-col gap-y-1.875 pb-1 pl-0.25">
            <div className="flex items-center gap-x-0.5 w-fit cursor-pointer">
              <input
                id={'sort__default'}
                className="field-radio"
                type="radio"
                value='default'
                name="sort-sidebar"
                onClick={() => resetSort()}
                checked={!activeSort}
                aria-label="Recommended"
              />
              <label htmlFor={'sort__default'} className="text-s whitespace-nowrap cursor-pointer">
                Recommended
              </label>
            </div>
            {sorts?.map((sort) => (
              <div key={sort.value} className="flex items-center gap-x-0.5 w-fit cursor-pointer">
                <input
                  id={`sort__${sort.value}`}
                  className="field-radio"
                  type="radio"
                  value={sort.value}
                  name="sort-sidebar"
                  onClick={() => handleSort(sort.value)}
                  checked={activeSort === sort.value}
                  aria-label={sort.label}
                />
                <label htmlFor={`sort__${sort.value}`} className="text-s whitespace-nowrap cursor-pointer">
                  {sort.label}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </x-modal>
  )
}
